import { Component, Inject, ChangeDetectionStrategy } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { CalendarMaxDate } from '@lla-platform/core/core-data-access'

export interface DatePickerDialogData {
  selectedValue?: Date | string
  maxDate: CalendarMaxDate
  minDate?: string
  label: string
}

@Component({
  selector: 'lla-date-picker-dialog',
  templateUrl: './date-picker-dialog.component.html',
  styleUrls: ['./date-picker-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DatePickerDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<DatePickerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DatePickerDialogData
  ) {}
}
